<template>
  <div class="c-detail-order-style">
    <cu-table :data="data" :pageData="condition" :isLoading="isLoading" @currentChange="currentChange" class="detail-buss-table-style">
      <el-table-column label="订单状态"  min-width="100">
        <template slot-scope="scope">{{scope.row.order_stage_name || '--'}}</template>
      </el-table-column>
      <el-table-column label="项目" min-width="150">
        <template slot-scope="scope">{{scope.row.project_name || '--'}}</template>
      </el-table-column>
      <el-table-column label="认购金额（元）" min-width="110">
        <template slot-scope="scope"><span v-comma:{fixed:2}="scope.row.subscription_amount"></span></template>
      </el-table-column>
      <el-table-column label="房屋总价（元）" min-width="110">
        <template slot-scope="scope"><span v-comma:{fixed:2}="scope.row.room_total_amount"></span></template>
      </el-table-column>
      <el-table-column label="佣金（元）" min-width="110">
        <template slot-scope="scope"><span v-comma:{fixed:2}="scope.row.brokerage"></span></template>
      </el-table-column>
      <el-table-column label="优惠返佣（元）" min-width="110">
        <template slot-scope="scope"><span v-comma:{fixed:2}="scope.row.discount_amount"></span></template>
      </el-table-column>
      <el-table-column label="创建人" min-width="100">
        <template slot-scope="scope">
          {{scope.row.creator_name || '--'}}
        </template>
      </el-table-column>
      <el-table-column label="创建时间" min-width="140">
        <template slot-scope="scope">
          <span v-analysis-time="scope.row.created_at"></span>
        </template>
      </el-table-column>
      <template slot="operate">
        <el-table-column label="操作" width="160" fixed="right" v-if="isShow">
          <template slot-scope="scope" >
            <div class="table-operation">
              <a class="ope-item" @click="toDetail(scope.row)" v-permission="'customer.order.detail'">详情</a>
              <a class="ope-item" @click="toFollowUp(scope.row)" v-if="scope.row.allow_follow_up" v-permission="'customer.order.detail.follow'">写跟进</a>
              <a class="ope-item" @click="toOrder(scope.row)" v-if="scope.row.allow_subscription" v-permission="'customer.order.detail.subscription'">认购</a>
              <a class="ope-item" @click="toSign(scope.row)" v-if="scope.row.allow_sign" v-permission="'customer.order.detail.sign'">签约</a>
              <a class="ope-item" @click="toSettle(scope.row)" v-if="scope.row.allow_settlement" v-permission="'customer.order.detail.settlement'">结佣</a>
              <a class="ope-item" @click="toRefuse(scope.row)" v-if="scope.row.allow_refund" v-permission="'customer.order.detail.refund'">退款</a>
            </div>
          </template>
        </el-table-column>
      </template>
    </cu-table>
  </div>
</template>
<script>
import {customeOrderList} from  '@/api/custome';
import TableComponent from '@/components/table/index';
import CuTable from '@/components/cTable';
export default {
  name: 'OrderInfo',
  props: {
    customeId: String | Number,
    emitName: String,
    activeName: String,
    baseInfo: Object
  },
  components: {
    CuTable
  },
  computed: {
    isShow ()  {
      return [1, 3, 4].indexOf(Number(this.baseInfo.status)) < 0;
    }
  },
  data () {
    return {
      data: [],
      condition: {
        page: 1,
        per_page: 10,
        total: 0
      },
      isLoading: false,
      hasDetailPermission: false
    }
  },
  async mounted () {
    this.initOrderList();
    this.hasDetailPermission = await this.$store.dispatch('user/hasPermission', 'customer.order.detail');
  },
  methods: {
    refrensh () {
      this.condition.page = 1;
      this.initOrderList();
    },
    openSubscibe () {

    },
    openOrder () {

    },
    toSettle (row) {
      this.$EventBus.$emit(this.emitName, {isOpen: true, category: 'settlement', params: {
        orderId: row.id,
        tabActiveName: this.activeName
      }});
    },
    toSign (row) {
      this.$EventBus.$emit(this.emitName, {isOpen: true, category: 'sign', params: {
        orderId: row.id,
        tabActiveName: this.activeName
      }});
    },
    toOrder (row) {
      this.$EventBus.$emit(this.emitName, {isOpen: true, category: 'subscribe', params: {
        orderId: row.id,
        tabActiveName: this.activeName,
        bussinessId: row.business_id,
        subscribeType: 'order'
      }});
    },
    // 写跟进-跳转
    toFollowUp (row) {
      let info = {};
      ['customer_id', 'customer_name', 'contact_id', 'contact_name', 'contact_tel', 'id'].map(v => info[v] = row[v]);
      this.$EventBus.$emit(this.emitName, {category: 'follow', params: {
        followType: 'order',
        tabActiveName: this.activeName,
        info
      }});
    },
    // 初始化订单列表
    async initOrderList () {
      if (!this.customeId) return null;
      this.isLoading = true;
      try {
        const res = await customeOrderList(this.customeId, {
          ...this.condition,
          customerId: this.customeId
        })
        this.data = res.data || [];
        this.$set(this.condition, 'total', res.total);
      } catch (error) {
        this.$message.error(error.msg || '操作失败，请重试')
      } finally {
        this.isLoading = false;
      }
    },
    currentChange (current) {
      this.$set(this.condition, 'page', current);
      this.initOrderList();
    },
    toRefuse (row) {
      this.$EventBus.$emit(this.emitName, {category: 'refund', params: {
        type: 'new',
        orderId: row.id,
        tabActiveName: this.activeName
      }});
    },
    toDetail (row) {
      this.$EventBus.$emit(this.emitName, {category: 'orderDetail', params: {
        type: 'new',
        orderId: row.id,
        bussinessId: row.business_id,
        tabActiveName: this.activeName
      }});
    }
  }
}
</script>
<style scoped lang="less">
.c-detail-order-style{
  .box();
  height: calc(100VH - 220px);
  -webkit-box-orient: vertical;
  .detail-buss-table-style{
    .boxFlexAll();
    padding-top: 15px;
  }
}
</style>